module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"t1":"Initial Public Offering","t2":"Subscription is open from","t3":"19-27 November, 2024","msg1":"Talabat Holding plc Initial Public Offering"},"ar":{"t1":"الــطــرح الــعــام الأولـي","t2":"الاكـتتـاب","t3":"19-27 نوفمبر 2024","msg1":"طلبات هولدينج بي إل سي الــطــرح الــعــام الأولـي"}}')
  delete Component.options._Ctor
}
